import React from "react";
import {
  IonPage,
  IonCol,
  IonRow,
  IonContent,
  IonGrid,
  IonButton,
  IonIcon,
} from "@ionic/react";
import { useHistory } from "react-router-dom";
import "../theme/AppStyles.css";
import { arrowUp, logoAndroid, logoApple } from "ionicons/icons";

const ForceUpdate: React.FC = () => {
  const history = useHistory();

  function delay() {
    setTimeout(() => {
      // executes when function times out
      history.push("./home");
    }, 3000);
  }
  delay();

  // const platform = Platform;
  // const isAndroid = platform.is("android");
  // const isIos = platform.is("ios");

  const _UpdateApple: React.FC = () => {
    return (
      <React.Fragment>
        <IonRow>
          <IonCol>
            <IonButton
              href="https://apps.apple.com/us/app/werkapp/id6446168426"
              target="_blank"
              // color="medium"
              size="large"
              expand="block"
              fill="solid"            >
              <IonIcon icon={logoApple}></IonIcon>
            </IonButton>
          </IonCol>
        </IonRow>
      </React.Fragment>
    );
  };

  const _UpdateAndroid: React.FC = () => {
    return (
      <React.Fragment>
        <IonRow>
          <IonCol>
            <IonButton
              href="https://play.google.com/store/apps/details?id=com.pipedream.werkapp&utm_source=na_Med"
              target="_blank"
              // color="medium"
              size="large"
              expand="block"
              fill="solid"            >
              <IonIcon color="success" icon={logoAndroid}></IonIcon>
            </IonButton>
            {/* <IonLabel>Android</IonLabel> */}
          </IonCol>
        </IonRow>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <IonPage>
        <IonContent>
          <div className="loginContainer">
            <span className="loginWrapper">
              <span className="logo">WerkApp</span>
              <br></br>
              <span className="title">Update Required</span>
              <IonGrid>
                <IonRow>
                  <IonCol></IonCol>
                </IonRow>
                <IonRow>
                  <IonCol>
                    <IonButton
                      href="https://apps.apple.com/us/app/werkapp/id6446168426"
                      target="_blank"
                      color="medium"
                      size="large"
                      expand="block"                      // fill="outline"
                    >
                      <IonIcon icon={logoApple}></IonIcon>
                    </IonButton>
                    {/* <IonLabel>Apple</IonLabel> */}
                  </IonCol>
                  <IonCol>
                    <IonButton
                      href="https://play.google.com/store/apps/details?id=com.pipedream.werkapp&utm_source=na_Med"
                      target="_blank"
                      // color="medium"
                      size="large"
                      expand="block"
                      fill="solid"                    >
                      <IonIcon color="success" icon={logoAndroid}></IonIcon>
                    </IonButton>
                    {/* <IonLabel>Android</IonLabel> */}
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol></IonCol>
                  <IonCol><strong>Apple</strong></IonCol>
                  <IonCol>or</IonCol>
                  <IonCol><strong>Android</strong></IonCol>
                  <IonCol></IonCol>
                </IonRow>
                <IonRow>
                  <IonCol></IonCol>
                  <IonCol><IonIcon icon={arrowUp}></IonIcon></IonCol>
                  <IonCol size="3"></IonCol>
                  <IonCol><IonIcon icon={arrowUp}></IonIcon></IonCol>
                  <IonCol></IonCol>
                </IonRow>
                <IonRow>
                  <IonCol>Click Here to Update</IonCol>
                </IonRow>
              </IonGrid>
            </span>
          </div>
        </IonContent>
      </IonPage>
    </React.Fragment>
  );
};

export default ForceUpdate;
